import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhMenuComponent } from './components/fh-menu.component';
import { RouterModule } from '@angular/router';
import { FhMenuDropdownComponent } from './components/childs/fh-menu-dropdown/fh-menu-dropdown.component';
import { FhMenuItemComponent } from './components/childs/fh-menu-item/fh-menu-item.component';
import { FhTextModule } from '@fh-client-interaction-frontends/fh-text';
import { FhButtonModule } from '@fh-client-interaction-frontends/fh-button';
import { FhMenuProviderService } from './helpers/providers/fh-menu-provider.service';
import { TranslateModule } from '@ngx-translate/core';
import { FhMenuFeaturesPipe } from './helpers/pipes/fh-menu-features/fh-menu-features.pipe';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  imports: [CommonModule, RouterModule, FhTextModule, FhButtonModule, TranslateModule, TooltipModule],
  declarations: [FhMenuComponent, FhMenuDropdownComponent, FhMenuItemComponent, FhMenuFeaturesPipe],
  exports: [FhMenuComponent, FhMenuItemComponent, FhMenuFeaturesPipe],
  providers: [FhMenuProviderService]
})
export class FhMenuModule {}
